// ----------------------------------------------------------------------------
// Template: 404
// ----------------------------------------------------------------------------
// 404 File Not Found Template
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/page-header/page-header';

// Styles
import './_404.scss';

function pageNotFoundLogic() {
    const defaultMessageContainer = document.querySelector('.default-message_container');
    const customMessageContainer = document.querySelector('.custom-message_container');
    const activeContainerClass   = 'active';
    const backLinkContainer      = document.querySelector('#back-link');
    const storeURLglobal         = "https://earthrated.com";

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const countryRedirect = urlParams.get('countryRedirect');
    var urlPathname = window.location.pathname;

    const caENSubfolder = '/en-ca';
    const caFRSubfolder = '/fr-ca';
    const euENSubfolder = '/en-eu';
    const euFRSubfolder = '/fr-eu';
    const ukSubfolder = '/en-uk';

    if( countryRedirect != null ){
        defaultMessageContainer.classList.remove(activeContainerClass);
        customMessageContainer.classList.add(activeContainerClass);

        if( countryRedirect == 'CA' ) {
            var storeName = 'Canada site',
                storeLink = storeURLglobal + caENSubfolder;
        } else if ( countryRedirect == 'US' ) {
            var storeName = 'USA site',
                storeLink = storeURLglobal;
        } else if ( countryRedirect == 'EU' ) {
            var storeName = 'Europe site',
                storeLink = storeURLglobal + euENSubfolder;
        } else if ( countryRedirect == 'GB' ) {
            var storeName = 'UK site',
                storeLink = storeURLglobal + ukSubfolder;
        }

        if( urlPathname != null ){
            if( urlPathname.includes(caENSubfolder) ){
                var urlPathname = urlPathname.replace(caENSubfolder,'');
            }
            else if( urlPathname.includes(caFRSubfolder) ){
                var urlPathname = urlPathname.replace(caFRSubfolder,'');
            }
            else if( urlPathname.includes(euENSubfolder) ){
                var urlPathname = urlPathname.replace(euENSubfolder,'');
            }
            else if( urlPathname.includes(euFRSubfolder) ){
                var urlPathname = urlPathname.replace(euFRSubfolder,'');
            }
            else if( urlPathname.includes(ukSubfolder) ){
                var urlPathname = urlPathname.replace(ukSubfolder,'');
            }
            var storeLink = storeLink + urlPathname;
        }

        backLinkContainer.href = storeLink;
        backLinkContainer.querySelector('.store-name').innerHTML = storeName;
    } else {
        customMessageContainer.classList.remove(activeContainerClass);
        defaultMessageContainer.classList.add(activeContainerClass);
    }

}

document.addEventListener('DOMContentLoaded', () => {
    if( document.querySelector('.template-404') ){
        pageNotFoundLogic();
    }
});
